// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__akgst","label":"Radio_label__IKmgR","checkMark":"Radio_checkMark__CiPw0","disabled":"Radio_disabled__2bTlo"};